import type { MouseEvent } from 'react'

import { Icon, IconNames, IconSizes } from 'atoms/Icon'
import { COLOR } from 'vars/index'
import { HintsArrowButtonSC } from './HintsArrowButton.styled'

export interface IHintsArrowButtonProps {
  direction: 'prev' | 'next'
  onClick: (event: MouseEvent) => void
}

export const HintsArrowButton = ({
  direction,
  onClick,
}: IHintsArrowButtonProps) => {
  const iconName =
    direction === 'prev' ? IconNames.angleLeft : IconNames.angleRight

  return (
    <HintsArrowButtonSC onClick={onClick} type='button'>
      <Icon
        name={iconName}
        size={IconSizes.xSm}
        color={COLOR.TEXT_ICON_SECONDARY}
      />
    </HintsArrowButtonSC>
  )
}
